// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('warehouse/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/warehouse/warehouseList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getWarehouse = createAsyncThunk('warehouse/getWarehouse', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/warehouse/warehouseEdit/${id}`)
    return response.data.Response.item
  } else {
    return response
  }
})

export const addWarehouse = createAsyncThunk('warehouse/addWarehouse', async (CreateWarehouse, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/warehouse/warehouseCreate`, {
    Request: {
      CreateWarehouse
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error(response.data.Response.Description)
  }

  await dispatch(getData(getState().warehouses.params))
  await dispatch(getAllData())
  return CreateWarehouse
})

export const updateWarehouse = createAsyncThunk('warehouse/addWarehouse', async (UpdateWarehouse, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/warehouse/warehouseUpdate`, {
    Request: {
      UpdateWarehouse
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error(response.data.Response.Description)
  }

  await dispatch(getData(getState().warehouses.params))
  await dispatch(getAllData())
  return UpdateWarehouse
})

export const changeStatus = createAsyncThunk('warehouse/changeStatus', async (ChangeStatusWarehouse, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/warehouse/warehouseChangeStatus`, {
    Request: {
      ChangeStatusWarehouse
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().warehouses.params))
  return ChangeStatusWarehouse
})

export const deleteWarehouse = createAsyncThunk('warehouse/deleteWarehouse', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/warehouse/warehouseDelete/${id}`)

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().warehouses.params))
  await dispatch(getAllData())
  return id
})

export const appCategoriesSlice = createSlice({
  name: 'warehouses',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedWarehouse: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getWarehouse.fulfilled, (state, action) => {
        state.selectedWarehouse = action.payload
      })
  }
})

export default appCategoriesSlice.reducer
